import axios from '@shared/helpers/axios';

export const apiPath = 'api/v2/contents';

export type ContentType = {
    WorkOfficeAddress?: string;
    WorkCallNumber?: string;
    WorkEmail?: string;
    WorkFacebookAccount?: string;
    WorkInstagramAccount?: string;
    WorkWaNumber?: string;
    WorkTwitterAccount?: string;
    WorkdayInfo?: {
        en?: string;
        id?: string;
    };
};

export interface ShowParamsType {
    include?: string;
}

export const getShowUrl = (params?: ShowParamsType): string => {
    const baseUrl = `${process.env.REACT_APP_API_URL}/${apiPath}/show/1`;
    if (params && params.include) {
        return `${baseUrl}?include=${params.include}`;
    }
    return baseUrl;
};

export const show = async (params?: ShowParamsType) => {
    const url = getShowUrl(params);
    return axios.get(url);
};
